// assets/color-mapping.js
window.colorHexMap = {
  'black': '#000000',
  'white': '#FFFFFF',
  'light grey': '#E0E0E0',
  'grey': '#A0A0A0',
  'dark grey': '#606060',
  'light red': '#FF6666',
  'red': '#FF0000',
  'dark red': '#CA0606',
  'light orange': '#FDB352',
  'orange': '#FE9001',
  'dark orange': '#E67300',
  'light yellow': '#FFFF7F',
  'yellow': '#FFED00',
  'dark yellow': '#FDC300',
  'lime': '#D2D808',
  'light blue': '#4FC2F1',
  'blue': '#008ED0',
  'dark blue': '#244A91',
  'light turquoise': '#40E0D0',
  'turquoise': '#03C1C7',
  'dark turquoise': '#009BA1',
  'light brown': '#DF9C29',
  'brown': '#A45B08',
  'dark brown': '#764104',
  'light green': '#A5C725',
  'green': '#08B008',
  'dark green': '#006400',
  'light pink': '#FF85EA',
  'pink': '#FF1CC3',
  'dark pink': '#DE02A3',
  'violet': '#800080',
  'gold': '#D2AB34',
  'silver': '#C0C0C0',
  'navy blue': '#293C4D',
  'desert grey': '#B6A589',
  'tundra grey': '#798BA1',
  'tundra': '#798BA1',
  'burning red': '#E42D25',
  'black matt': '#1D1D1B',
  'black gloss': '#010101',
  'white matt': '#FAFAFA',
  'white gloss': '#FEFEFE',
  'red carmine': '#E30000',
  'silver metallic gloss': '#C1C1C1',
  'anthracite metallic gloss': '#585757',
  'blue king gloss': '#0C02A1',
  'gold metallic gloss': '#D1AA33',
  'brown metallic matt': '#AF5E0E',
  'yellow husqvarna' : '#FFD100',
  'blue husqvarna' : '#002551',
  'orange ktm' : '#FF66000',
  'green kawasaki': '#32CD32',
  'blue yamaha' : '#00238B',
  'black matte': '#1D1D1B',
  'white matte': '#FAFAFA',
  'brown metallic matte': '#AF5E0E',
};


